export const FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_REQUEST = 'FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_REQUEST'
export const FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_SUCCESS = 'FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_SUCCESS'
export const FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_FALUIRE = 'FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_FALUIRE'
